import React from "react";
import values from "lodash/values";
import pick from "lodash/pickBy";
import { Link } from "react-router";
import { RaisedButton } from "material-ui";
import { Table, Tr, Td, Sort } from "reactable";

import FilmTable from "./partials/film-table.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import FilmActions from "../actions/FilmActions";
import FilmStore from "../stores/FilmStore";

import config from "../config";
import UserStore from "../stores/UserStore";

import WorkingIndicator from "./partials/working-indicator.jsx";

class Films extends React.Component {
  constructor(props) {
    super(props);
  }

  static getStores() {
    return [UserStore, FilmStore];
  }

  static getPropsFromStores() {
    return FilmStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  componentWillMount() {
    FilmActions.fetchAllForCreator();
  }

  render() {
    let styles = this.getStyles(),
      films = values(
        pick(this.props.films, f => {
          return (
            f.event_bucket === this.props.params.eventBucketId &&
            f.type === "livestream"
          );
        })
      );

    if (films.length === 0 && FilmStore.getState().isFetching) {
      return <WorkingIndicator fullPage={true} />;
    }

    let upcomingFilms = films.filter(
      f =>
        f.virtual_content &&
        [
          "livestream_not_created",
          "livestream_creating",
          "livestream_created"
        ].indexOf(f.virtual_content.status) !== -1 &&
        (!f.end_time || new Date() < new Date(f.end_time))
    );
    let completedFilms = films.filter(
      f => upcomingFilms.indexOf(f) === -1 && f.virtual_content
    );

    return (
      <div>
        <p style={{ fontSize: "11pt" }}>
          Welcome to the Livestreaming Hub. After creating a screening that
          contains a livestream in your{" "}
          <Link
            to={`/event_buckets/${this.props.params.eventBucketId}/virtual_festival`}
          >
            Virtual screenings
          </Link>
          , you can manage that stream here.
        </p>
        <FilmTable
          films={upcomingFilms}
          eventBucket={this.props.params.eventBucketId}
          livestreamView={true}
        />
        {completedFilms.length ? (
          <div style={{ marginTop: "2em" }}>
            <h2>Past livestreams</h2>
            <FilmTable
              films={completedFilms}
              eventBucket={this.props.params.eventBucketId}
              livestreamView={true}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(Films);



// WEBPACK FOOTER //
// ./src/app/components/virtual-festival-livestreaming-hub.jsx